import { useCallback, useRef } from 'react';

type ScriptWithBodyReturnType = {
  executeScript: (body: string, id: string) => void;
  removeScript: () => void;
};

export const useScriptWithBody = (): ScriptWithBodyReturnType => {
  const scriptRef = useRef<HTMLScriptElement | null>(null);

  const executeScript = useCallback((body: string, id: string) => {
    // Remove existing script with the same ID if it exists
    const existingScript = document.querySelector(`script[id="${id}"]`);
    if (existingScript) {
      existingScript.parentNode?.removeChild(existingScript);
    }

    scriptRef.current = document.createElement('script');
    // Wrap the script content in an IIFE to create a new scope
    scriptRef.current.innerHTML = `(function() { ${body} })();`;
    scriptRef.current.async = true;
    scriptRef.current.id = id;
    document.body.appendChild(scriptRef.current);
  }, []);

  const removeScript = useCallback(() => {
    if (scriptRef.current && scriptRef.current.parentNode === document.body) {
      document.body.removeChild(scriptRef.current);
    }
  }, []);

  return {
    executeScript,
    removeScript,
  };
};
